import React from 'react';
import { Add, Remove } from '@mui/icons-material';
import { IconButton, Row, Text } from 'library/ui';

interface NumberStepperProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    unit?: string;
}

export function NumberStepper({ value, onChange, min = 1, max, unit }: NumberStepperProps) {
    return (
        <Row gap="sm">
            <IconButton icon={Remove} iconSize={18} disabled={value <= min} onClick={() => onChange(value - 1)} />
            <Text weight="bold">{value}</Text>
            {unit && (
                <Text size="sm" tone="secondary">
                    {value === 1 ? unit : `${unit}s`}
                </Text>
            )}
            <IconButton
                icon={Add}
                iconSize={18}
                disabled={max !== undefined && value >= max}
                onClick={() => onChange(value + 1)}
            />
        </Row>
    );
}
